<app-header-toolbar-v2></app-header-toolbar-v2>

<main class="main-content w-full px-4">
  <router-outlet></router-outlet>
</main>
